import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { Accessor, Component, createEffect, createSignal } from 'solid-js';
import { useGoogleMaps } from "./GoogleMapsProvider";

export type MarkerDto = {
    ArtworkLocationId: number;
    City: string;
    Country: string;
    ItemCount: number;
    Title: string;
    Name: string;
    Latitude: number;
    Longitude: number;
}
export type HeatmapDto = {
    Weight: number;
    Latitude: number;
    Longitude: number;
}
type MapProps = {
    data: Accessor<{ markers: MarkerDto[]; heatmap: HeatmapDto[] }|null>;
    onMarkerClicked: (marker: google.maps.Marker, map: google.maps.Map) => void;
    height: Accessor<string>;
    width: Accessor<string>;
    mode: Accessor<string | undefined>;
};

export const Map : Component<MapProps> = (props) => {
    let cluster: any;    
    let heatmap: google.maps.visualization.HeatmapLayer|null;
    let markers: google.maps.Marker[] = [];
    let map: google.maps.Map;
    let isMapReady = false;
    const clearMarkers = () => {
        if (!map) {
            return;
        }
        if (cluster) {
            cluster.removeMarkers(markers);
        }
        markers.forEach(marker => marker.setMap(null));
        markers = [];
    };
    const clearHeatmap = () => hideHeatmap();
    const showMarkers = () => {
        markers.forEach(marker => marker.setMap(map));
        if (cluster) {
            cluster.addMarkers(markers);
        }
    };
    const hideMarkers = () => {
        markers.forEach(marker => marker.setMap(null));
        if (cluster) {
            cluster.removeMarkers(markers);
        }
    };
    const showHeatmap = () => {
        if (heatmap) {
            heatmap?.setMap(map);
        }
    };
    const hideHeatmap = () => {
        if (!map) {
            return;
        }
        if (heatmap) {
            heatmap.setMap(null);
        }
    }
    const fitMapMarkerBounds = ()  => {
        console.log("Map :: fitBounds()");
        if (!map) {
            console.log("Map :: !map");
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        markers.forEach(m => bounds.extend(m.getPosition() as google.maps.LatLng));
        map.fitBounds(bounds);
    };
    const createHeatmap = (heatmapData: HeatmapDto[]): google.maps.visualization.HeatmapLayer => {
        const _heatmap = heatmapData?.map((x) => {
            return {
                location: new google.maps.LatLng(x.Latitude, x.Longitude),
                weight: x.Weight
            };
        });
        const __heatmap = new google.maps.visualization.HeatmapLayer({ data: _heatmap });
        __heatmap.set("radius", 30);
        return __heatmap;
    };
    const createMarkers = (markersData: MarkerDto[], map: google.maps.Map) => {
        const markers = markersData.map((item) => {
            const marker = new google.maps.Marker({
                position: new google.maps.LatLng(item.Latitude, item.Longitude),
                title: item.Name ?? "<no name>"
            });
            marker.data = item;
            google.maps.event.addListener(marker, "click", () => props.onMarkerClicked(marker, map));
            return marker;
        });
        return markers;
    };
    const createMap = (element: HTMLDivElement, google: any) => {
        const mapOpts: google.maps.MapOptions = {
            zoom: 20
        };
        const map = new google.maps.Map(element, mapOpts);
        return map;
    };
    const update = () => {
        console.log("Map :: update()");
        clearMarkers();
        clearHeatmap();
        const data = props.data();
        if (data != null) {
            console.log("Map :: data != null");
            markers = createMarkers(data.markers, map);
            cluster = new MarkerClusterer({ map: map, markers: markers });
            heatmap = createHeatmap(data.heatmap);
            fitMapMarkerBounds();
            resizeMap();
        };
    };
    const resizeMap = () => google.maps.event.trigger(map, "resize");
    const heatmapMode = () => {
        const bounds = map?.getBounds() as google.maps.LatLngBounds;
        hideMarkers();
        showHeatmap();
        if (bounds) map.fitBounds(bounds, 0);
    };
    const markersMode = () => {
        const bounds = map?.getBounds() as google.maps.LatLngBounds;
        hideHeatmap();
        showMarkers();
        if (bounds) map.fitBounds(bounds, 0);
    };
    const applyMode = () => {
        if (!map) return;
        switch (props.mode()) {
            case "heatmap": {
                heatmapMode();
                break;
            }
            case "markers": {
                markersMode();
                break;
            }
            default: break;
        }
    };
    createEffect(() => {
        if (props.mode()) {
            console.log("props.mode()");
            if (isMapReady) {
                applyMode();
            }
        }
    });
    const setupElement = async (element: HTMLDivElement) => {
        const googleMaps = await useGoogleMaps();
        map = createMap(element, googleMaps);
        isMapReady = true;
        update();
        applyMode();
        console.log({ map });
    };
return (
<div ref={setupElement} style={{ width: props.width(), height: props.height() }}></div>);
}